import { Grid } from '@mui/material';
import { FC, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ControlledTextInput, WsButton, WsTypography, WsTypoVariants } from 'wisestep-base';

import { DeleteIconButton } from '../../crmSettings/components/StyledIconButtons';
export interface WorkspaceUserCreditsProps {
  allocatedData;
  onSaveHandler(data, key);
  onDeleteHandler(key);
}
const WorkspaceUserCredits: FC<WorkspaceUserCreditsProps> = ({
  allocatedData,
  onSaveHandler,
  onDeleteHandler,
}) => {
  const [edit, setEdit] = useState(-1);
  const methods = useForm();
  const { handleSubmit } = methods;
  const actionHandler = (data, key: string, index: number, type: string) => {
    const tempData = allocatedData;
    const handler = {
      ['onEdit']: () => {
        tempData[key] = data;
        setEdit(-1);
        methods.reset();
        onSaveHandler(tempData[key], key);
      },
      ['onDelete']: () => {
        onDeleteHandler(key);
      },
    };
    handler[type]();
  };

  return (
    <>
      {allocatedData &&
        Object.keys(allocatedData).map((key, index) =>
          index === edit ? (
            <Grid key={key} item container xs={12} component="form" mb={2}>
              <Grid item xs={5} pr={2}>
                <WsTypography variant={WsTypoVariants.BODY1}>{key}</WsTypography>
              </Grid>
              <FormProvider {...methods}>
                <Grid item xs={4}>
                  <ControlledTextInput
                    type="number"
                    name="email"
                    defaultValue={allocatedData[key]}
                  />
                </Grid>
                <Grid item xs={1.5}>
                  <WsButton
                    onClick={handleSubmit((data) =>
                      actionHandler(data.email ?? allocatedData[key], key, index, 'onEdit')
                    )}
                  >
                    Save
                  </WsButton>
                </Grid>
              </FormProvider>
            </Grid>
          ) : (
            <Grid key={key} item container xs={12} mb={2}>
              <Grid item xs={5} pr={2}>
                <WsTypography variant={WsTypoVariants.BODY1}>{key}</WsTypography>
              </Grid>
              <Grid item xs={4}>
                <WsTypography variant={WsTypoVariants.BODY1}>{allocatedData[key]}</WsTypography>
              </Grid>
              <Grid item xs={1.5}>
                <DeleteIconButton
                  onClick={handleSubmit((data) =>
                    actionHandler(data.email ?? allocatedData[key], key, index, 'onDelete')
                  )}
                />
              </Grid>
              <Grid item xs={1.5}>
                <WsButton onClick={() => setEdit(index)}>Edit</WsButton>
              </Grid>
            </Grid>
          )
        )}
    </>
  );
};

export default WorkspaceUserCredits;
